var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React, { useCallback, useState, useMemo } from "react";
import { Calendar, FormField } from "../index";
import dayjs from "dayjs";
import classnames from "classnames";
import { moment2Date } from "../_util/aformutils";
import "./style/index.less";
const CalendarFormItem = (_a) => {
    var { label = "日历", itemName = "date", form, tips = "", required = false } = _a, calendarRestProps = __rest(_a, ["label", "itemName", "form", "tips", "required"]);
    const [calendarVisible, setCalendarVisible] = useState(false);
    const { getFieldValue, setFieldsValue } = form;
    const calendarOnConfirm = (startTime, endTime) => {
        const timeArr = [
            dayjs(startTime).format("YYYY-MM-DD"),
            dayjs(endTime).format("YYYY-MM-DD"),
        ];
        setFieldsValue({
            [itemName]: timeArr,
        });
        setCalendarVisible(false);
    };
    const renderCalendarText = useMemo(() => {
        const calendarArr = getFieldValue(itemName);
        if (calendarArr && calendarArr.length && calendarArr[0]) {
            return `${calendarArr[0].split(" ")[0]}~${calendarArr[1].split(" ")[0]}`;
        }
        return tips || `请选择${label}`;
    }, [getFieldValue(itemName)]);
    const renderDefaultTimeValue = useCallback(() => {
        const calendarArr = getFieldValue(itemName);
        if (calendarArr && calendarArr[0] && calendarArr[1]) {
            return [
                moment2Date(calendarArr[0]),
                moment2Date(calendarArr[1]),
            ];
        }
        return [new Date(), new Date()];
    }, [getFieldValue(itemName)]);
    return (<div>
      <FormField label={label} required={required} form={form} itemName={itemName} requiredTips={`请选择${label}`} controlClassName="tui-calendar-form" content={<div className={classnames("text-dom", {
        active: renderCalendarText.indexOf("请选择") > -1,
    })} onClick={() => setCalendarVisible(true)}>
            {renderCalendarText}
          </div>}/>
      <Calendar {...calendarRestProps} visible={calendarVisible} defaultValue={renderDefaultTimeValue()} onCancel={() => setCalendarVisible(false)} onConfirm={calendarOnConfirm}/>
    </div>);
};
export default CalendarFormItem;
